import { render, staticRenderFns } from "./CommentListModal.vue?vue&type=template&id=1fef6ce6&"
import script from "./CommentListModal.vue?vue&type=script&lang=ts&"
export * from "./CommentListModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommentListModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports